import { render, staticRenderFns } from "./InterventionDetails.vue?vue&type=template&id=8f53670c"
import script from "./InterventionDetails.vue?vue&type=script&lang=js"
export * from "./InterventionDetails.vue?vue&type=script&lang=js"
import style0 from "./InterventionDetails.vue?vue&type=style&index=0&id=8f53670c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports